import { useParams, usePathname } from "next/navigation";

type SubjectParams = {
  subjectId?: string;
  paperId?: string;
}

export default function usePathParams() {
  const {
    subjectId = '',
    paperId = '',
  } = useParams() as SubjectParams;
  const path = usePathname();
  let tab: 'subject' | 'notes' | 'paper' | '' = '';
  if (subjectId && path.includes('/notes')) {
    tab = 'notes';
  } else if (subjectId && paperId) {
    tab = 'paper';
  } else if (subjectId) {
    tab = 'subject';
  } else {
    tab = '';
  }
  return {
    subjectId,
    paperId,
    tab,
  };
}


export function useSubjectId() {
  const {
    subjectId = '',
  } = useParams() as {
    subjectId: string;
  };
  return subjectId;
}

export function usePaperId() {
  const {
    paperId = '',
  } = useParams() as {
    paperId: string;
  };
  return paperId;
}